<div id="modal-content-wrapper" [formGroup]="form">
  <div class="card card-secondary card-outline">
    <div class="card-header bg-light" cdkDragBoundary="html" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
      cdkDragHandle>
      <h4 class="card-title mb-0">{{ this.titulo }}</h4>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="fechar()"><i class="fas fa-times"></i></button>
      </div>
    </div>

    <div class="card-body p-0">
      <div class="table-container p-3">

        <!-- Nome -->
        <div class="row">
          <div class="form-group col-md-12">
            <label for="select-agente" class="mb-1">Nome</label>
            <ng-select id="select-agente" formControlName="agentePublicoId"
              [ngClass]="{ 'is-invalid': submit && form.controls['agentePublicoId'].invalid }">
              <ng-option *ngFor="let element of agentes" [value]="element.id">{{ element.nome }}</ng-option>
            </ng-select>
            <div *ngIf="submit && form.controls['agentePublicoId'].invalid" class="invalid-feedback">
              Campo obrigatório
            </div>
          </div>
        </div>

        <!-- Datas e dias -->
        <div class="row">
          <div class="form-group col-md-4">
            <label for="data-inicio" class="mb-1">Data Início</label>
            <input type="text" id="data-inicio" placeholder="dd/mm/aaaa" data-mask="date"
              class="form-control form-control-sm suaClassDatePicker" autocomplete="off" bsDatepicker
              formControlName="dataInicio" [maxDate]="maxDateInicio"
              [ngClass]="{ 'is-invalid': submit && form.controls['dataInicio'].invalid }" />
            <div *ngIf="submit && form.controls['dataInicio'].invalid" class="invalid-feedback">
              <div *ngIf="form.controls['dataInicio'].errors.required">Campo obrigatório</div>
              <div *ngIf="form.get('dataInicio')?.hasError('dataMaiorQueFim')">A data de início não pode ser maior que a
                data de fim.</div>
            </div>
          </div>

          <div class="form-group col-md-4">
            <label for="data-fim" class="mb-1">Data Fim</label>
            <input type="text" id="data-fim" placeholder="dd/mm/aaaa" data-mask="date"
              class="form-control form-control-sm suaClassDatePicker" autocomplete="off" bsDatepicker
              formControlName="dataFim" [minDate]="minDateFim"
              [ngClass]="{ 'is-invalid': submit && form.controls['dataFim'].invalid }" />
            <div *ngIf="submit && form.controls['dataFim'].invalid" class="invalid-feedback">
              <div *ngIf="form.controls['dataFim'].errors.required">Campo obrigatório</div>
            </div>
          </div>

          <div class="form-group col-md-4">
            <label class="mb-1">Dias Corridos</label>
            <input type="text" class="form-control form-control-sm" formControlName="diasCorridos" readonly />
          </div>
        </div>

        <!-- Salário e Custo Final -->
        <div class="row">
          <div class="form-group col-md-4">
            <label class="mb-1">Salário</label>
            <input type="text" class="form-control form-control-sm"
              [value]="formatarValorVisual(form.get('salario')?.value)" (input)="onInputSalario($event)"
              [ngClass]="{ 'is-invalid': submit && form.controls['salario'].invalid }" />
            <div *ngIf="submit && form.controls['salario'].invalid && form.controls['salario'].errors?.min"
              class="invalid-feedback">
              Informe um salário válido
            </div>
          </div>

          <div class="form-group col-md-4">
            <label class="mb-1">Custo Final</label>
            <input type="text" class="form-control form-control-sm"
              [value]="formatarValorVisual(form.get('custoFinal')?.value)" readonly />
          </div>
        </div>

      </div>
    </div>

    <div class="card-footer">
      <div class="btn-group" [hidden]="visualizar">
          <button class="btn btn-primary btn-sm mr" (click)="salvar(false)">
              <i class="far fa-save"></i> Salvar
          </button>
          <button type="button" class="btn btn-primary btn-sm mr dropdown-toggle dropdown-icon" data-toggle="dropdown" aria-expanded="false"></button>
          <div class="dropdown-menu" role="menu">
              <a class="dropdown-item" (click)="salvar(false)">Salvar</a>
              <a class="dropdown-item" (click)="salvar(true)">Salvar e fechar</a>
          </div>
      </div>
  
      <button type="button" class="btn btn-default btn-sm" (click)="fechar()">
          <i class="fas fa-times"></i> {{visualizar ? 'Sair' : 'Cancelar' }}
      </button>
    </div>

  </div>
</div>